'use strict';

var OnlineLogitCalibrationReviewPanelDirective = function OnlineLogitCalibrationReviewPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/online-logit-calibration-review-panel.html'),
    controller: 'OnlineLogitCalibrationReviewPanelController',
    scope: {
      screen: '@',
      selectedCalibrationData: '=',
      screenState: '='
    },
    link: function link(scope) {
      scope.renderLogitSharesData();
      scope.$on('online-logit-calibration:scenario-toggle', scope.handleViewToggle);
      scope.$on('online-logit-calibration:logit-shares-reset', scope.removeUpdates);
      scope.$on('online-logit-calibration:updated-logit-shares', scope.captureUpdates);
      scope.$on('$stateChangeStart', scope.cleanUp);
      scope.$on('online-logit-calibration:show-unsaved-dialog', scope.showUnsavedChangesDialog);
      scope.$on('save-modal:calibration-analysis-recordChanges', scope.getLocalUpdatesAndSave);
      scope.$on('online-logit-calibration:profile-updates', scope.saveLogitProfiles);
      scope.$on('grid:clearAndLoadData:online-logit-calibration-review', scope.refreshGridAndChart);
    }
  };
};
OnlineLogitCalibrationReviewPanelDirective.$inject = [];
module.exports = OnlineLogitCalibrationReviewPanelDirective;